import { type App, inject } from 'vue'
import { detect } from 'detect-browser'

export interface IsMobileAgentPlugin {
    isMobileAgent: boolean
}

const key = 'app.plugin.is-mobile-agent'

export function installIsMobileAgent(
    app: App,
    userAgent: string | undefined
): IsMobileAgentPlugin {
    const isMobileAgent = getIsMobileAgent(userAgent)

    const plugin: IsMobileAgentPlugin = {
        isMobileAgent,
    }

    app.provide(key, plugin)

    return plugin
}

export function useIsMobileAgent(): boolean {
    return useIsMobileAgentPlugin().isMobileAgent
}

function useIsMobileAgentPlugin(): IsMobileAgentPlugin {
    return inject(key) as IsMobileAgentPlugin
}

function getIsMobileAgent(userAgent: string | undefined): boolean {
    const browser = detect(userAgent)

    switch (browser?.os) {
        case 'iOS':
        case 'Android OS':
        case 'BlackBerry OS':
        case 'Windows Mobile':
        case 'Amazon OS':
            return true
        default:
            return false
    }
}
